// data/categories.ts (your existing file — no changes needed)
export interface Category {
  id: string;
  title: string;
  subtitle: string;
  image: string;
  href?: string;
}

export interface Stat {
  id: string;
  value: number;
  suffix: string;
  label: string;
  iconName: 'users' | 'worker' | 'globe' | 'badge';
}

export const categoriesData: Category[] = [
  { id: 'brass', title: 'Brass', subtitle: 'Collection', image: '/categories/brassv2.webp', href: '/products' },
  { id: 'copper', title: 'Copper', subtitle: 'Collection', image: '/categories/copperv2.webp', href: '/products' },
  { id: 'wood', title: 'Wood', subtitle: 'Collection', image: '/categories/woodv2.webp', href: '/products' },
  { id: 'marble', title: 'Marble', subtitle: 'Collection', image: '/categories/marblev2.webp', href: '/products' },
  { id: 'aluminium', title: 'Aluminium', subtitle: 'Collection', image: '/categories/aluminiumv2.webp', href: '/products' },
  { id: 'home-decor', title: 'Home Decor', subtitle: 'Curated', image: '/categories/homedecorv2.webp', href: '/products' },
  { id: 'furniture', title: 'Furniture', subtitle: 'Curated', image: '/categories/furniturev2.webp', href: '/products' },
  { id: 'lighting', title: 'Lighting', subtitle: 'Curated', image: '/categories/lightv211.webp', href: '/products' },
];

export const categoryStatsData: Stat[] = [
  { id: 'products', value: 5000, suffix: '+', label: 'Products', iconName: 'users' },
  { id: 'workers', value: 100, suffix: '+', label: 'Skilled Workers', iconName: 'worker' },
  { id: 'exported', value: 50, suffix: '+', label: 'Countries Exported', iconName: 'globe' },
  { id: 'quality', value: 100, suffix: '%', label: 'Quality Assured', iconName: 'badge' },
];